import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppShell } from "@/components/AppShell";

import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import DomainsPage from "@/pages/DomainsPage";
import RegistrarAccountsPage from "@/pages/RegistrarAccountsPage";
import UsersPage from "@/pages/UsersPage";
import MigrationsPage from "@/pages/MigrationsPage";

export default function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <Toaster
                    position="bottom-right"
                    richColors
                    toastOptions={{
                        style: {
                            fontFamily: "Satoshi, sans-serif",
                            borderRadius: "0.85rem",
                        },
                    }}
                />
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route
                        element={
                            <ProtectedRoute>
                                <AppShell />
                            </ProtectedRoute>
                        }
                    >
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<DashboardPage />} />
                        <Route path="/domains" element={<DomainsPage />} />
                        <Route path="/migrations" element={<MigrationsPage />} />
                        <Route
                            path="/registrar-accounts"
                            element={
                                <ProtectedRoute adminOnly>
                                    <RegistrarAccountsPage />
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/users"
                            element={
                                <ProtectedRoute adminOnly>
                                    <UsersPage />
                                </ProtectedRoute>
                            }
                        />
                    </Route>
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}
